import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, requireWhatsapp = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-mono-fig text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (requireWhatsapp && user.role !== "admin" && !user.whatsapp_number) {
    return <Navigate to="/complete-profile" state={{ from: location.pathname }} replace />;
  }
  return children;
}
